import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "site-shell" }
const _hoisted_2 = { class: "topbar" }
const _hoisted_3 = { class: "container topbar-inner" }
const _hoisted_4 = { href: "tel:+493012345670" }
const _hoisted_5 = { href: "mailto:praxis@zahnzentrum-demo.de" }
const _hoisted_6 = { class: "header" }
const _hoisted_7 = { class: "container nav-wrap" }
const _hoisted_8 = { class: "container footer-inner" }

import {ref} from 'vue';
import {ArrowRight, Clock3, Mail, Menu, Phone, X} from 'lucide-vue-next';
import '@/assets/styles/main.css'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const menuOpen = ref(false);
const closeMenu = () => menuOpen.value = false

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "demo-ribbon" }, "Unverbindliche Website-Demo · Alle Angaben sind fiktiv", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, [
          _createVNode(_unref(Clock3), { size: 15 }),
          _cache[1] || (_cache[1] = _createTextVNode(" Mo–Do 8–18 Uhr · Fr 8–14 Uhr", -1))
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("a", _hoisted_4, [
            _createVNode(_unref(Phone), { size: 15 }),
            _cache[2] || (_cache[2] = _createTextVNode(" 030 12345670", -1))
          ]),
          _createElementVNode("a", _hoisted_5, [
            _createVNode(_unref(Mail), { size: 15 }),
            _cache[3] || (_cache[3] = _createTextVNode(" E-Mail", -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("header", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "brand",
          onClick: closeMenu
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createElementVNode("span", { class: "brand-mark" }, "Z", -1),
            _createElementVNode("span", null, [
              _createElementVNode("strong", null, "Zahnzentrum"),
              _createElementVNode("small", null, "am Stadtpark")
            ], -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("button", {
          class: "menu-button",
          "aria-label": "Menü",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (menuOpen.value=!menuOpen.value))
        }, [
          (menuOpen.value)
            ? (_openBlock(), _createBlock(_unref(X), { key: 0 }))
            : (_openBlock(), _createBlock(_unref(Menu), { key: 1 }))
        ]),
        _createElementVNode("nav", {
          class: _normalizeClass({open:menuOpen.value})
        }, [
          _createVNode(_component_router_link, {
            to: "/",
            onClick: closeMenu
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("Start", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/leistungen",
            onClick: closeMenu
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("Leistungen", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/praxis",
            onClick: closeMenu
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("Praxis", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/team",
            onClick: closeMenu
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("Team", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/karriere",
            onClick: closeMenu
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createTextVNode("Karriere", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/kontakt",
            onClick: closeMenu
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createTextVNode("Kontakt", -1)
            ]))]),
            _: 1
          })
        ], 2)
      ])
    ]),
    _createElementVNode("main", null, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({Component}) => [
          _createVNode(_Transition, {
            name: "page",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("footer", null, [
      _createElementVNode("div", _hoisted_8, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "brand footer-brand" }, [
          _createElementVNode("span", { class: "brand-mark" }, "Z"),
          _createElementVNode("span", null, [
            _createElementVNode("strong", null, "Zahnzentrum"),
            _createElementVNode("small", null, "am Stadtpark")
          ])
        ], -1)),
        _createElementVNode("p", null, "© " + _toDisplayString(new Date().getFullYear()) + " Musterwebsite · Keine reale Praxis", 1),
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, { to: "/impressum" }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createTextVNode("Impressum", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/datenschutz" }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createTextVNode("Datenschutz", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})